import { AnyAction } from "redux";

import { stationsActions } from "../reducer";

export const resetBestRouteStations = (): AnyAction => stationsActions.setBestRouteStations();
